// we need to maintain a fix order of vendors that will be called or the build will produce an error (as we have multiple entry points)
import 'assets/core/js/module/sliderManager'
import 'assets/core/js/module/selectManager'

import coreSearch from 'assets/core/js/entry/search'
import newsletter from 'assets/core/js/module/newsletter'
// import { initModal } from 'assets/core/js/module/paymentFacilities'
import dataLayer from 'assets/core/js/page/search/dataLayer'
import productFavorite from 'assets/core/js/page/search/product/favorite'
import searchForm from 'assets/themes/campings/js/module/searchForm'
import blocksToggle from 'assets/themes/campings/js/page/search/blocksToggle'
import bookingReward from 'assets/themes/campings/js/page/search/bookingReward'
import budgetSlider from 'assets/themes/campings/js/page/search/budgetSlider'
import filters from 'assets/themes/campings/js/page/search/filters'
import form from 'assets/themes/campings/js/page/search/form'
import imagesSliders from 'assets/themes/campings/js/page/search/imagesSliders'
import loading from 'assets/themes/campings/js/page/search/loading'
import map from 'assets/themes/campings/js/page/search/map'
import openProductPageLinks from 'assets/themes/campings/js/page/search/openProductPageLinks'
import results from 'assets/themes/campings/js/page/search/results'
import sorting from 'assets/themes/campings/js/page/search/sorting'
import fixedDates from 'assets/themes/campings/js/page/thematic/fixed-dates'

document.addEventListener('DOMContentLoaded', function () {
  // initModal()

  dataLayer()
  imagesSliders.init()

  budgetSlider()
  openProductPageLinks()
  sorting()
  blocksToggle()
  loading()
  filters()
  map()
  productFavorite()
  bookingReward()
  searchForm()

  coreSearch()
  newsletter()
  form()
  results()

  if (document.querySelector('[data-theme=fixed-dates]') !== null) {
    fixedDates.init()
  }
})
